<template>
  <div class="home__header">
    <div class="home__header-overlay"></div>
    <!-- <img
      alt=""
      src="@/assets/motifs/motif1.svg"
      class="home__motif --1 noselect"
    />
    <img
      alt=""
      src="@/assets/clusters/cluster1.svg"
      class="home__motif --2 noselect"
    />
    <img
      alt=""
      src="@/assets/clusters/cluster2.svg"
      class="home__motif --3 noselect"
    />
    <img
      alt=""
      src="@/assets/motifs/motif3.svg"
      class="home__motif --4 noselect"
    /> -->
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <Header />
        </div>
      </div>
    </div>
  </div>
  <div class="home__black">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 home__section"
        >
          <TrustedBy />
        </div>
      </div>
    </div>
  </div>
  <div class="home_light">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner home__section">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <Suite />
        </div>
      </div>
    </div>
  </div>
  <div class="home__black">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner home__section">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <AppIntro />
        </div>
      </div>
    </div>
  </div>
  <div class="home_light">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner home__section">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <InteldeskHome />
        </div>
      </div>
    </div>
  </div>
  <div class="home_wave2">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 title sr_prevent_flickering"
          v-scrollreveal
        >
          <h1>Case Studies</h1>
          <h4>
            Check out these crypto investigations where Bubblemaps made a
            difference.
          </h4>
        </div>
      </div>
      <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <wistia-player
            media-id="uxr1on7txj"
            seo="false"
            class="video-player"
            aspect="1.7777777777777777"
          ></wistia-player>
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 cbsnews-logo"
        >
          <img src="@/assets/logos/medias/cbsnews.png" alt="CBS News logo" />
        </div>
      </div>
    </div>
    <CaseStudiesCarousel />
    <div class="mdc-layout-grid">
      <div class="home__section home__form">
        <SubscribeForm />
      </div>
    </div>
  </div>
</template>

<script>
import SubscribeForm from "@/components/molecules/SubscribeForm.vue";
import TrustedBy from "@/components/molecules/TrustedBy.vue";
import AppIntro from "@/components/molecules/AppIntro.vue";
import Header from "@/components/organisms/Header/Header.vue";
import Suite from "@/components/molecules/Suite.vue";
import InteldeskHome from "@/components/molecules/InteldeskHome.vue";
import CaseStudiesCarousel from "@/components/organisms/CaseStudies/CaseStudiesCarousel.vue";

export default {
  name: "Navigation",
  components: {
    SubscribeForm,
    TrustedBy,
    AppIntro,
    Header,
    Suite,
    InteldeskHome,
    CaseStudiesCarousel,
  },
  methods: {
    openVideo() {
      this.$refs.videoDialog.open();
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/variables";

.home__section {
  padding: 60px 0;
}

.home__header {
  background: #120612;
  margin-top: -56px;
  padding-top: 56px;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("../assets/backgrounds/wave.png") no-repeat center;
    background-size: cover;
    opacity: 0;
    animation: fadeInBackground 2s ease-in 1s forwards;
  }

  @keyframes fadeInBackground {
    to {
      opacity: 1;
    }
  }

  .mdc-layout-grid {
    position: relative;
    z-index: 1;
  }
}

@media (min-width: $mdc-tablet) {
  .home__header {
    margin-top: -64px;
    padding-top: 64px;
  }
}

.home__bottom {
  background: url("../assets/backgrounds/blur.png") no-repeat center;
  background-size: cover;
}

.home__motif {
  position: absolute;
  opacity: 0.6;
  z-index: 0;

  &.--1 {
    bottom: -86px;
    right: -993px;
    height: 719px;
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    mask-image: linear-gradient(16deg, rgba(0, 0, 0, 1) 50%, transparent);
  }

  &.--2 {
    height: 102px;
    bottom: 586px;
    right: -40px;
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    mask-image: linear-gradient(16deg, rgba(0, 0, 0, 1) 50%, transparent);
  }

  &.--3 {
    height: 100px;
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    top: 130px;
    mask-image: linear-gradient(311deg, rgb(0, 0, 0), #000000a6);
  }

  &.--4 {
    height: 533px;
    bottom: -354px;
    left: -133px;
    transform: rotate(1deg) scaleX(-1);
    mask-image: linear-gradient(24deg, rgba(0, 0, 0, 1) 50%, transparent);
  }
}

@media (max-width: 1229px) {
  .home__motif {
    &.--1 {
      bottom: -100px;
      left: -450px;
      height: 400px;
      -webkit-transform: scaleX(1);
      transform: scaleX(1);
      right: auto;
    }

    &.--2 {
      bottom: 0;
      left: 87px;
      -webkit-transform: scaleX(1);
      transform: scaleX(1);
      right: auto;
    }

    &.--3 {
      -webkit-transform: scaleX(1);
      transform: scaleX(1);
      right: 0;
    }

    &.--4 {
      display: none;
    }
  }
}

@media (max-width: $mdc-grid-tablet) {
  .home__motif {
    &.--1 {
      bottom: -65px;
      left: -354px;
      height: 300px;
    }

    &.--2 {
      height: 75px;
      bottom: 10px;
      left: 51px;
    }

    &.--3 {
      right: 0;
    }
  }
}

.home__testimonials {
  padding-bottom: 0;
}

.home__form {
  max-width: 1000px;
  margin: auto;
}

.home__black {
  background-color: $theme-almost-black;
}

.home_middle {
  background: url("../assets/backgrounds/blur.png") no-repeat center;
  background-size: cover;
}

.home_light {
  background: url("../assets/backgrounds/light.png") no-repeat center;
  background-size: cover;
}

.home_wave2 {
  background: url("../assets/backgrounds/wave2.png") no-repeat center;
  background-size: cover;

  .video-player {
    max-width: 800px;
    margin: auto;
  }

  .cbsnews-logo {
    display: flex;

    img {
      max-width: 150px;
      margin: auto;
      margin-bottom: 50px;
    }
  }

  .title {
    text-align: center;
    padding-top: 70px;
    padding-bottom: 70px;

    h1 {
      margin-top: 0;
      margin-bottom: 1rem;
      @include scaling-title(2.1rem, 400px, 200px);
    }
  }

  @media (max-width: $mdc-tablet) {
    .title {
      padding-top: 50px;
      padding-bottom: 50px;
    }

    .cbsnews-logo {
      img {
        max-width: 100px;
      }
    }
  }
}

.home__header-overlay {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  opacity: 1;
  mix-blend-mode: hard-light;
  background: radial-gradient(
      100% 100% at var(--15-x-position) var(--15-y-position),
      #872279 0%,
      transparent
    ),
    radial-gradient(
      100% 100% at var(--14-x-position) var(--14-y-position),
      #3062b1 0%,
      transparent
    ),
    radial-gradient(
      100% 100% at var(--16-x-position) var(--16-y-position),
      #3e2188 0%,
      transparent
    ),
    transparent;
  animation-name: main;
  animation-iteration-count: infinite;
  animation-duration: 6s;
  transition-timing-function: ease-in;
}
@property --14-x-position {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 19.8046875%;
}
@property --14-y-position {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 56.56250000000001%;
}
@property --15-x-position {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 82.34375%;
}
@property --15-y-position {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 33.8671875%;
}
@property --16-x-position {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 79.609375%;
}
@property --16-y-position {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 66.9140625%;
}
:root {
  --14-x-position: 19.8046875%;
  --14-y-position: 56.56250000000001%;
  --15-x-position: 82.34375%;
  --15-y-position: 33.8671875%;
  --16-x-position: 79.609375%;
  --16-y-position: 66.9140625%;
}
@keyframes main {
  25% {
    --14-x-position: 15%;
    --14-y-position: 15%;
    --15-x-position: 85%;
    --15-y-position: 80%;
  }
  50% {
    --14-x-position: 80%;
    --14-y-position: 15%;
    --15-x-position: 15%;
    --15-y-position: 85%;
    --16-x-position: 20%;
    --16-y-position: 20%;
  }
}
</style>
